import script from "./RenderFunction.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenderFunction.vue?vue&type=script&setup=true&lang=ts"

import "./RenderFunction.vue?vue&type=style&index=0&id=993f8210&lang=css"

const __exports__ = script;

export default __exports__